import { isSeason, SeasonT } from '@/constants/seasons';

export const adaptSeasonForApi = (value: SeasonT | SeasonT[]): string =>
    Array.isArray(value) ? value.join('|') : value;

export const adaptSeasonFromApi = (value?: string | SeasonT[]): SeasonT[] => {
    if (!value) {
        return [];
    }

    if (Array.isArray(value)) {
        return value;
    }

    return value
        .split('|')
        .map((season) => season.trim())
        .filter((element) => isSeason(element));
};
